import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Target icon
 *
 * @category Business
 */
const Target = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M28.624 15.487c-.848-.226-2.398.328-2.42-1.018a10.36 10.36 0 0 0-8.481-8.662c-.294-.056-.701-.09-.905-.282-.52-.408 0-2.172-.577-2.454-1.277-.532-.52 2.08-1.085 2.454-.159.135-.396.192-.69.248-4.399.656-7.927 4.094-8.662 8.481-.056.294-.09.701-.283.905-.407.52-2.16 0-2.453.577-.26.576.26.848 1.062.825.837 0 1.482-.056 1.595.747.317 2.261 1.368 4.432 2.963 5.993 1.65 1.843 4.138 2.555 6.468 3.166.6.486-.17 2.476.837 2.533.95.034.282-2.183.836-2.533 2.33-.61 4.818-1.323 6.468-3.166 1.844-1.651 2.556-4.139 3.167-6.48.373-.497 1.922-.045 2.363-.475a.516.516 0 0 0-.056-.814l-.136-.056zm-11.908 9.42c-.362-.532.046-1.674-.373-2.228-1.142-.837-.837 1.413-1.018 1.945-.101.294-.316.396-.655.362-3.924-.498-7.215-3.789-7.713-7.701-.203-1.38 2.307-.125 2.5-1.3-.09-.973-2.115-.283-2.398-.826-.18-4.026 3.664-7.667 7.61-8.164 1.109-.136.532 1.436.86 2.16.531.825 1.108 0 1.018-.883-.012-.599.034-1.153.395-1.244 2.047-.01 4.071 1.154 5.485 2.533 1.334 1.414 2.748 3.596 2.476 5.61-.271.418-1.515.135-2.058.384-.44.18-.44.7 0 .882.543.26 1.787-.034 2.058.384.204 4.116-4.025 8.12-8.085 8.165z"
        />
      </svg>
    );
  }
);

Target.displayName = 'Target';

export { Target };
